/**
 * Implements a wallet overview section with
 * chain selector, wallet statistics and search input
 */
import { useNavigate } from 'react-router-dom';
import {
  IWalletOverview,
  IWalletTradesCountAndVolume,
} from '@kattana-io/common';
import ChainSelector from '../../../../components/ChainSelector';
import { networksWithWalletData } from '../../../../components/NetworkSelector/core';

import './styles.scss';
import WalletMobile from './Wallet';

interface IOverviewMobileProps {
  wallet: IWalletOverview | null;
  tradesAndVolume: IWalletTradesCountAndVolume | null;
  loading: boolean;
  chain?: string;
  address?: string;
}

const OverviewMobile = ({
  wallet,
  tradesAndVolume,
  loading,
  chain,
  address,
}: IOverviewMobileProps) => {
  const navigate = useNavigate();

  const onChainSelect = (value: string) => {
    navigate(`/en/wallet-overview/${value}/${address}`);
  };

  return (
    <div className='overview_mobile'>
      <ChainSelector
        selected={chain || ''}
        onSet={onChainSelect}
        networks={networksWithWalletData}
      />
      <WalletMobile
        wallet={wallet}
        tradesAndVolume={tradesAndVolume}
        chain={chain}
        address={address}
        loading={loading}
      />
    </div>
  );
};

export default OverviewMobile;
